export const convertToCSV = (data) => {
  const header = Object.keys(data[0]).join(",");
  const rows = data.map((row) =>
    Object.values(row)
      .map((value) => {
        // If the value is an array, join it with commas and enclose in double quotes
        if (Array.isArray(value)) {
          return `"${value.join(", ")}"`;
        }
        // If the value is a string containing commas, enclose it in double quotes
        if (typeof value === "string") {
          return `"${value.replace(/"/g, '""')}"`;
        }
        // Otherwise, return the value as is
        return value;
      })
      .join(",")
  );
  return [header, ...rows].join("\n");
};

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function stripHtmlTags(str) {
  if (str === null) {
    return null;
  } else if (str === "") {
    return "";
  } else {
    return str.replace(/(<([^>]+)>)/gi, "");
  }
}

export function decodeHtml(htmlString) {
  var txt = document.createElement("textarea");
  txt.innerHTML = htmlString;
  return txt.value;
}

export function cleanString(str) {
    if (str === null) {
        return null;
    }
    return decodeHtml(stripHtmlTags(str));
}

export function formatCurrency(price, currencyCode, locale = "en-US") {
  // Check if price or currencyCode is null
  if (price == null || currencyCode == null) {
      return "-";
  }

  // Format the price using the currencyCode and locale
  try {
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currencyCode,
    }).format(price);
  } catch {
    // Invalid currency code - fall back to plain number with code suffix
    return `${price.toLocaleString(locale)} ${currencyCode}`;
  }
}

export const isEmpty = obj => Object.keys(obj).length === 0;

// Numeric date pattern in the browser locale's field order, as a dayjs format
// string for antd date pickers (en-US → MM/DD/YYYY, en-GB → DD/MM/YYYY,
// de-DE → DD.MM.YYYY). Derived once from a probe date; only part order and
// separators matter. Direction marks (RTL locales) are stripped so the
// pattern stays parseable as typed input.
export const localeDateFormat = new Intl.DateTimeFormat(undefined, {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
})
  .formatToParts(new Date(2001, 11, 31))
  .map((part) => {
    if (part.type === "day") return "DD";
    if (part.type === "month") return "MM";
    if (part.type === "year") return "YYYY";
    return part.value.replace(/[‎‏]/g, "");
  })
  .join("");

// Locale-aware medium date ("Oct 12, 2026" / "12 Oct 2026") for places where
// a date is read back rather than edited (search summary, PDF exports) —
// unambiguous across regions, unlike numeric forms.
export function formatDateMedium(date) {
  return new Intl.DateTimeFormat(undefined, { dateStyle: "medium" }).format(
    date instanceof Date ? date : date.toDate()
  );
}
